import { render } from "./AddTax.vue?vue&type=template&id=504a631f"
import script from "./AddTax.vue?vue&type=script&lang=js"
export * from "./AddTax.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Projects/Vue/one-invoice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__